import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'

import { userManager } from '@/shared/auth/oidc'

export const Route = createFileRoute('/auth/login')({
  validateSearch: z.object({ redirect: z.string().optional() }),
  component: Login,
})

function Login() {
  const { redirect } = Route.useSearch()
  const { t } = useTranslation()

  useEffect(() => {
    // Não há tela de login própria: a autenticação é do Keycloak. Esta rota só
    // existe como alvo do redirect da guarda, e reencaminha na hora.
    void userManager.signinRedirect(redirect === undefined ? {} : { state: { returnTo: redirect } })
  }, [redirect])

  return (
    <div className="bg-canvas text-ink-muted grid min-h-dvh place-items-center text-sm">
      <p role="status">{t('states.loading')}</p>
    </div>
  )
}
